import DownloadService from "../common/core/download.service";

class DocumentDownloadService extends DownloadService {
  constructor(documentId, resource) {
    super(["documents", documentId, "download", resource]);
  }
}

export default DocumentDownloadService;
